import Modal from 'react-modal';
import { useState } from 'react';
import { IPostInputModel } from 'inputModels';
import { serialize } from 'object-to-formdata';
import { IPostViewModel } from 'viewModels';
import { ReactComponent as EditPen } from '../../../assets/icons/editPen.svg';
import { Content, Header } from './styles';
import MapSearch from '../../MapSearch';
import { Button } from '../../Buttons/Button';
import { PostType } from '../../../types/enums';
import { PostController } from '../../../controller/PostController';
import { usePosts } from '../../../context/posts';
import { useAuth } from '../../../context';

interface ModalCheckInLocationProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

export function ModalCheckInLocation({ isOpen, onRequestClose }: ModalCheckInLocationProps) {
  const { user } = useAuth();
  const { setPosts } = usePosts();
  const [geoLocation, setGeoLocation] = useState<google.maps.LatLngLiteral | undefined>();

  const handleShareLocation = async () => {
    if (geoLocation?.lat && geoLocation?.lng) {
      const post: IPostInputModel = {
        body: '',
        type: PostType.LOCATION,
        latitude: geoLocation.lat,
        longitude: geoLocation.lng,
      };
      const formData = serialize(post, { indices: true });
      await PostController.insert(formData).then((id) => {
        const newPost: IPostViewModel = {
          id,
          body: '',
          type: PostType.LOCATION,
          createdAt: new Date(),
          latitude: geoLocation.lat,
          longitude: geoLocation.lng,
          createdBy: {
            id: user.id,
            firstName: user.firstName,
            lastName: user.lastName,
            profilePictureId: user.profilePictureId,
          },
        };
        onRequestClose();
        setPosts((prevState) => [newPost, ...prevState]);
      });
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-edit-modal-content">
      <Header>
        <div className="subHeader">
          <EditPen />
          <h1>Procurar Localização</h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={onRequestClose}>
            x
          </button>
        </div>
      </Header>
      <Content>
        <MapSearch
          action="select-place"
          options={{
            changeMarkerWhenPanChange: true,
          }}
          onPlace={(geoLocationData) => setGeoLocation(geoLocationData)}
        />
        <div className="containerButton">
          <Button
            text="Compartilhar localização"
            dimensions={{
              width: '15rem',
              height: '2rem',
            }}
            onClick={handleShareLocation}
            color="background_white"
            background="primary"
          />
        </div>
      </Content>
    </Modal>
  );
}
